import styled from 'styled-components';

export const title = styled.div`
    width: 100px;
    text-align: center;
`;

